import controller from './payWithAlipay.controller';
import template from './payWithAlipay.html';

const PayWithAlipayDetailsComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller
};

export default PayWithAlipayDetailsComponent;



/** WEBPACK FOOTER **
 ** ./client/app/components/services/payWithAlipay/payWithAlipay.component.js
 **/